import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const YoutubeDevice169: FC<Props> = (props) => (
  <Root viewBox="0 0 145.78 300.88" {...props}>
    <defs>
      <style>
        {
          '.youtube16-9_svg__cls-2{fill:#f5f5f5}.youtube16-9_svg__cls-3{fill:#9e9e9e}.youtube16-9_svg__cls-4{fill:#424242}.youtube16-9_svg__cls-5{fill:#4286f5}.youtube16-9_svg__cls-8{fill:none;stroke:#f5f5f5;stroke-miterlimit:10}'
        }
      </style>
    </defs>
    <g id="youtube16-9_svg__\u30EC\u30A4\u30E4\u30FC_2" data-name="\u30EC\u30A4\u30E4\u30FC 2">
      <g id="youtube16-9_svg__\u30EC\u30A4\u30E4\u30FC_1-2" data-name="\u30EC\u30A4\u30E4\u30FC 1">
        <rect width={145.78} height={300.88} rx={21.72} />
        <path
          d="M124 7.33h-14.16v1.92a7.59 7.59 0 01-7.59 7.59H43.14a7.59 7.59 0 01-7.59-7.59V7.33h-15A14.31 14.31 0 006.28 21.64v257.6a14.31 14.31 0 0014.31 14.31H124a14.31 14.31 0 0014.31-14.31V21.64A14.31 14.31 0 00124 7.33z"
          fill="#fff"
        />
        <rect x={53.71} y={286.02} width={34.73} height={3.52} rx={1.76} />
        <path className="youtube16-9_svg__cls-2" d="M6.3 96.35h131.96v25.39H6.3z" />
        <path className="youtube16-9_svg__cls-3" d="M29.96 110.41h21.38v3.94H29.96zM29.96 104.39h34.36v4.21H29.96z" />
        <path className="youtube16-9_svg__cls-2" d="M13.66 132.45h50.81v3.94H13.66zM13.68 126.44h81.65v4.21H13.68z" />
        <circle className="youtube16-9_svg__cls-4" cx={20.21} cy={110.27} r={6.55} />
        <rect className="youtube16-9_svg__cls-5" x={100.05} y={105.28} width={28.09} height={9.87} rx={2.89} />
        <rect className="youtube16-9_svg__cls-5" x={100.05} y={203.09} width={28.09} height={9.87} rx={4.94} />
        <path
          className="youtube16-9_svg__cls-2"
          d="M29.96 187.41h21.38v3.94H29.96zM13.24 206.79h21.38v3.94H13.24zM29.96 181.4h34.36v4.21H29.96z"
        />
        <circle className="youtube16-9_svg__cls-4" cx={20.21} cy={187.28} r={6.55} />
        <path fill="#fe0000" d="M100.05 185.75h28.09v3.86h-28.09z" />
        <path fill="#e62d27" d="M6.28 23.04h132.01v73.17H6.28z" />
        <circle className="youtube16-9_svg__cls-3" cx={18.77} cy={158.32} r={5.23} />
        <circle className="youtube16-9_svg__cls-3" cx={43.93} cy={158.32} r={5.23} />
        <circle className="youtube16-9_svg__cls-3" cx={69.09} cy={158.32} r={5.23} />
        <circle className="youtube16-9_svg__cls-3" cx={94.26} cy={158.32} r={5.23} />
        <circle className="youtube16-9_svg__cls-3" cx={119.42} cy={158.32} r={5.23} />
        <path className="youtube16-9_svg__cls-8" d="M6.3 174.53h131.36M6.3 198.75h131.36" />
        <path className="youtube16-9_svg__cls-3" d="M65.82 225.24h34.5v3.94h-34.5z" />
        <path className="youtube16-9_svg__cls-2" d="M76.08 233.63h14.91v3.94H76.08zM65.91 241.08h18.71v3.94H65.91z" />
        <path className="youtube16-9_svg__cls-3" d="M65.83 219.22h55.43v4.21H65.83z" />
        <path className="youtube16-9_svg__cls-4" d="M12.86 218.43h49.86v27.63H12.86z" />
        <path fill="#fcc642" d="M65.9 231.19h8.27v8.27H65.9z" />
        <path className="youtube16-9_svg__cls-3" d="M65.76 258.02h34.5v3.94h-34.5z" />
        <path className="youtube16-9_svg__cls-2" d="M65.76 266.41h14.91v3.94H65.76zM65.76 273.87h18.71v3.94H65.76z" />
        <path className="youtube16-9_svg__cls-3" d="M65.76 252.01h55.43v4.21H65.76z" />
        <path className="youtube16-9_svg__cls-4" d="M12.86 251.21h49.86v27.63H12.86z" />
      </g>
    </g>
  </Root>
);

const Root = styled('svg')();
export default YoutubeDevice169;
